<template>
    <div class="doughnut-wrap">
        <div class="row">
            <div class="col-12 col-6 sm col-md">
                <DoughnutChart :chartData="chartValues" :width="100" :height="200"></DoughnutChart>
            </div>
        </div>
        <div class="row caption">
            <div class="col">
                <span>{{ caption }}</span>
                <span>{{ value | percentage}}</span>
            </div>
        </div>
    </div>

</template>

<script>
    import DoughnutChart from './DoughnutChart'

    export default {
        name: "DoughnutChartWrap",
        components: {
            DoughnutChart
        },
        props: [
            'value',
            'caption'
        ],
        computed: {
            chartValues() {
                return {
                    datasets: [
                        {
                            data: [this.value, 100 - this.value],
                            backgroundColor: ['#05ce9f', '#004666'],
                            borderWidth: 0
                        }
                    ]
                }
            }
        },
        filters: {
            percentage(value) {
                if (!value) return 0 + '%';
                return parseInt(value) + '%';
            }
        }
    }
</script>

<style scoped lang="stylus">
    .doughnut-wrap
        margin-top 3rem

        .caption
            text-align center

            span
                display block

                &:nth-child(1)
                    color $color-blue-petrol
                    font-family $font-bold
                    font-size 1.7rem

                &:nth-child(2)
                    color $color-turquoise
                    font-family $font-bold
                    font-size 3.6rem
                    line-height 4rem
</style>